import AxiosConfig from '../config/axiosConfigApiPlataform'
/* Remover esse defaultParams das chamadas quando a passagem do empresaId estiver funcionando pelo axios-config.js */
const defaultParams = {
  params: {
    empresaId: 1 // Obter esse valor dinamicamente quando o Jaleklinico também for usado pro B2B
  }
}

export const PlataformNotificationApi = {

  async getNotification (id, pagina) {
    if (id) {
      let response = await AxiosConfig.api().get(`/notificacoes/${id}`, { params: { page: pagina } })
      return response.data
    }
    let response = await AxiosConfig.api().get(`/notificacoes?page=${pagina}`, defaultParams)
    return response.data
  },

  async getNotificationByType (id) {
    let response = await AxiosConfig.api().get(`/notificacoes/tipo/${id}`, defaultParams)
    return response.data
  },

  async getNotificationTypes () {
    let response = await AxiosConfig.api().get(`/notificacoes-tipos`, {}, defaultParams)
    return response.data
  },

  async registerVisualization (notificacoesIds) {
    if (notificacoesIds) { // Ultimas notificacoes
      let response = await AxiosConfig.api().put(`/notificacoes`,
        {
          'ultimas_notificacoes': notificacoesIds
        },
        defaultParams)
      return response.data
    }
    // Todas as notificacoes
    let response = await AxiosConfig.api().put(`/notificacoes`, {}, defaultParams)
    return response.data
  },

  async registerAccess (id) {
    let response = await AxiosConfig.api().put(`/notificacoes/${id}`)
    return response.data
  }

}

export default PlataformNotificationApi
